<div class="search-bar">
    <div class="search-icon-wrapper"> </div>
    <app-search-input
        (click)="showGlobalSearchResult = true"
        (close)="showGlobalSearchResult = false"
        ngDefaultControl
        [formControl]="searchControl"></app-search-input>

    <app-global-search-output 
        *ngIf="doWeNeedToShowSearchResult()"
        [showRecentActions]="doWeNeedToShowHistory()">
    </app-global-search-output>
</div>